import { AlertDialog, Button, Flex } from "@radix-ui/themes";
import { router } from "@inertiajs/react";
import { Application } from "@/types/shared";

interface Props {
  application: Pick<Application, "id" | "status">;
}
export default function WithdrawFromEventButton({ application }: Props) {
  const handleWithdraw = (applicationId: number) => {
    router.patch(`/applications/${applicationId}/withdraw`);
  };

  // Application should not be able to be withdrawn if it is rejected.
  if (application.status === "withdrawn" || application.status === "rejected")
    return <></>;

  return (
    <AlertDialog.Root>
      <AlertDialog.Trigger>
        <Button
          color="yellow"
          disabled={
            application.status === "withdrawn" ||
            application.status === "rejected"
          }
        >
          Withdraw
        </Button>
      </AlertDialog.Trigger>
      <AlertDialog.Content maxWidth="450px">
        <AlertDialog.Title>Withdraw Application</AlertDialog.Title>
        <AlertDialog.Description size="2">
          Are you sure? You will not be able reapply to this event on this date.
        </AlertDialog.Description>

        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray">
              Keep
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button
              variant="solid"
              color="red"
              onClick={() => handleWithdraw(application.id)}
            >
              Yes, withdraw
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
}
